import { render, staticRenderFns } from "./UploadLuminexIGM.vue?vue&type=template&id=6fb06ddc&"
import script from "./UploadLuminexIGM.vue?vue&type=script&lang=js&"
export * from "./UploadLuminexIGM.vue?vue&type=script&lang=js&"
import style0 from "./UploadLuminexIGM.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports